<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Add New Report Requests
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <form ref="observer" tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                        <div class="grid">
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Customer Id 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <api-data-source   api-path="components_data/customer_id_option_list" >
                                                            <template v-slot="req">
                                                                <Dropdown class="w-full" :class="getErrorClass('customer_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlcustomer_id"  v-model="formData.customer_id" :options="req.response" label="Customer Id"  placeholder="Select a value ..." >
                                                                </Dropdown> 
                                                                <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                            </template>
                                                        </api-data-source>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Meter Id 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <api-data-source   api-path="components_data/meter_id_option_list" >
                                                            <template v-slot="req">
                                                                <Dropdown class="w-full" :class="getErrorClass('meter_id')"   :loading="req.loading"   optionLabel="label" optionValue="value" ref="ctrlmeter_id"  v-model="formData.meter_id" :options="req.response" label="Meter Id"  placeholder="Select a value ..." >
                                                                </Dropdown> 
                                                                <small v-if="isFieldValid('meter_id')" class="p-error">{{ getFieldError('meter_id') }}</small> 
                                                            </template>
                                                        </api-data-source>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Report Type 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlreport_type" v-model.trim="formData.report_type"  label="Report Type" type="text" placeholder="Enter Report Type"      
                                                        class=" w-full" :class="getErrorClass('report_type')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('report_type')" class="p-error">{{ getFieldError('report_type') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Start Date 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <Calendar :showButtonBar="true" class="w-full" :class="getErrorClass('start_date')" dateFormat="yy-mm-dd" v-model="formData.start_date" :showIcon="true"     mask="YYYY-MM-DD" outlined dense      />
                                                        <small v-if="isFieldValid('start_date')" class="p-error">{{ getFieldError('start_date') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        End Date 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <Calendar :showButtonBar="true" class="w-full" :class="getErrorClass('end_date')" dateFormat="yy-mm-dd" v-model="formData.end_date" :showIcon="true"     mask="YYYY-MM-DD" outlined dense      />
                                                        <small v-if="isFieldValid('end_date')" class="p-error">{{ getFieldError('end_date') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Status 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlstatus" v-model.trim="formData.status"  label="Status" type="text" placeholder="Enter Status"      
                                                        class=" w-full" :class="getErrorClass('status')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('status')" class="p-error">{{ getFieldError('status') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Report File Type 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <div class="mb-3">
                                                            <Uploader :class="getErrorClass('report_file_type')" upload-path="fileuploader/upload/report_file_type" v-model="formData.report_file_type" :fileLimit="1" :maxFileSize="3000000" accept=".jpg,.png,.gif,.jpeg" :multiple="false" label="Choose files or drop files here" />
                                                        </div>
                                                        <small v-if="isFieldValid('report_file_type')" class="p-error">{{ getFieldError('report_file_type') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Report File Link 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <div class="mb-3">
                                                            <Uploader :class="getErrorClass('report_file_link')" upload-path="fileuploader/upload/report_file_link" v-model="formData.report_file_link" :fileLimit="1" :maxFileSize="3000000" accept=".jpg,.png,.gif,.jpeg" :multiple="false" label="Choose files or drop files here" />
                                                        </div>
                                                        <small v-if="isFieldValid('report_file_link')" class="p-error">{{ getFieldError('report_file_link') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="showSubmitButton" class="text-center my-3">
                                            <Button class="p-button-primary p-button-rounded" type="submit" label="Submit" icon="pi pi-send" :loading="saving" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useAddPage } from '@/composables/addpage.js';
	const props = defineProps({
		pageName : {
			type : String,
			default : 'report_requests',
		},
		routeName : {
			type : String,
			default : 'report_requestsadd',
		},
		apiPath : {
			type : String,
			default : 'report_requests/add',
		},
		submitButtonLabel: {
			type: String,
			default: "Submit",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterSave: {
			type: String,
			default: "Record added successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
		pageData: { // use to set formData default values from another page
			type: Object,
			default: () => {} 
		},
	});
	const app = useApp();
	const formDefaultValues = {
		customer_id: "", 
		meter_id: "", 
		report_type: "", 
		start_date: "", 
		end_date: "", 
		status: "ready", 
		report_file_type: "", 
		report_file_link: "", 
	};
	const formData = reactive({ ...formDefaultValues });
	//form validation rules
	const rules = computed(() => {
		return {
			customer_id: { numeric },
			meter_id: { numeric },
			report_type: {  },
			start_date: {  },
			end_date: {  },
			status: {  },
			report_file_type: {  },
			report_file_link: {  }
		}
	});
	const v$ = useVuelidate(rules, formData); // form validation
	const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
	// perform custom validation before submit form
	// set custom form fields
	// return false if validation fails
	function beforeSubmit(){
		return true;
	}
	// after form submited to api
	// reset form data.
	// redirect to another page
	function afterSubmit(response) {
		app.flashMsg(props.msgAfterSave);
		page.setFormDefaultValues(); //reset form data
		if(props.redirect) app.navigateTo(`/report_requests`);
	}
	//page state
	const {
		submitted, // form submitted state - Boolean
		saving, // form api submiting state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page methods
	const {
		submitForm, //submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Add New Report Requests";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
	});
	// expose page object for other components access
	defineExpose({
		page
	});
</script>
<style scoped>
</style>
